var _a;
import { __assign } from "tslib";
import { optionsMap } from 'pro-gallery-lib';
import { migratePrivateControllers } from './controllers/private-controllers';
import { fullscreenFixedOptions } from './fullscreenFixedStyles';
var galleryFixedOptions = (_a = {},
    _a[optionsMap.layoutParams.crop.enable] = false,
    _a[optionsMap.layoutParams.targetItemSize.unit] = 'SMART',
    _a);
var optionsConverter = function (options) {
    var fullscreenOptions = __assign({}, options);
    var galleryOptions = __assign({}, options);
    if (options[optionsMap.behaviourParams.item.clickAction]) {
        var mapNativeItemClick = {
            MAGNIFY: 'MAGNIFY',
            LINK: 'LINK',
            NOTHING: 'NOTHING',
            EXPAND: 'ACTION',
            FULLSCREEN: 'ACTION',
            ACTION: 'ACTION',
        };
        galleryOptions[optionsMap.behaviourParams.item.clickAction] =
            mapNativeItemClick[options[optionsMap.behaviourParams.item.clickAction]] || 'NOTHING';
    }
    if (options[optionsMap.layoutParams.crop.ratios]) {
        var ratios = [Number(options[optionsMap.layoutParams.crop.ratios])];
        galleryOptions[optionsMap.layoutParams.crop.ratios] = ratios;
        fullscreenOptions[optionsMap.layoutParams.crop.ratios] = ratios;
    }
    galleryOptions = migratePrivateControllers(galleryOptions);
    return {
        galleryOptions: Object.assign({}, galleryOptions, galleryFixedOptions),
        fullscreenOptions: Object.assign({}, fullscreenOptions, fullscreenFixedOptions),
    };
};
export default optionsConverter;
//# sourceMappingURL=proGalleryOptionsBuilder.js.map